const REGISTRY_KEY = '__pledgesRuntimeRegistry';

function registry() {
    if (!window[REGISTRY_KEY]) {
        window[REGISTRY_KEY] = {};
    }
    return window[REGISTRY_KEY];
}

export function registerInitPledgesPageContent(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerInitPledgesPageContent: fn is required');
    }
    registry().initPledgesPageContent = fn;
}

export function initPledgesPageContent(opts) {
    const fn = registry().initPledgesPageContent;
    if (typeof fn !== 'function') {
        throw new Error('initPledgesPageContent is not registered');
    }
    return fn(opts || {});
}

export function registerEnsurePledgeRowExpanderInitialized(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerEnsurePledgeRowExpanderInitialized: fn is required');
    }
    registry().ensurePledgeRowExpanderInitialized = fn;
}

export function ensurePledgeRowExpanderInitialized() {
    const fn = registry().ensurePledgeRowExpanderInitialized;
    if (typeof fn !== 'function') {
        throw new Error('ensurePledgeRowExpanderInitialized is not registered');
    }
    return fn();
}

export function registerReloadPledgesPage(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerReloadPledgesPage: fn is required');
    }
    registry().reloadPledgesPage = fn;
}

export function registerOpenPledgesPage(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerOpenPledgesPage: fn is required');
    }
    registry().openPledgesPage = fn;
}

export function openPledgesPage(onDone, options) {
    const fn = registry().openPledgesPage;
    if (typeof fn === 'function') {
        fn(onDone, options);
        return;
    }
    if (typeof onDone === 'function') {
        onDone();
    }
}

export function reloadPledgesPage(onDone, rowIds) {
    const fn = registry().reloadPledgesPage;
    if (typeof fn === 'function') {
        fn(onDone, rowIds);
        return;
    }
    openPledgesPage(onDone);
}

export function registerReloadPledgesFromUrl(fn) {
    if (typeof fn !== 'function') {
        throw new Error('registerReloadPledgesFromUrl: fn is required');
    }
    registry().reloadPledgesFromUrl = fn;
}

export function reloadPledgesFromUrl(url, options) {
    const fn = registry().reloadPledgesFromUrl;
    if (typeof fn !== 'function') {
        throw new Error('reloadPledgesFromUrl is not registered');
    }
    return fn(url, options);
}

export function registerPledgeRowExpander(expander) {
    if (!expander || typeof expander !== 'object') {
        throw new Error('registerPledgeRowExpander: expander is required');
    }
    registry().pledgeRowExpander = expander;
}

export function getPledgeRowExpander() {
    const expander = registry().pledgeRowExpander;
    if (!expander) {
        throw new Error('getPledgeRowExpander is not registered');
    }
    return expander;
}

export function collapseAllPledgeRows() {
    const expander = getPledgeRowExpander();
    if (typeof expander.collapseAllRows !== 'function') {
        throw new Error('collapseAllPledgeRows: collapseAllRows is required');
    }
    expander.collapseAllRows();
}

export function registerPledgesGrid(grid) {
    registry().pledgesGrid = grid || null;
}

export function getPledgesGrid() {
    return registry().pledgesGrid || null;
}

export function registerPledgesConfig(config) {
    if (!config || typeof config !== 'object') {
        throw new Error('registerPledgesConfig: config is required');
    }
    registry().pledgesConfig = config;
}

export function getPledgesConfig() {
    const config = registry().pledgesConfig;
    if (!config || typeof config !== 'object') {
        throw new Error('getPledgesConfig: pledgesConfig is not registered');
    }
    return config;
}
